module.exports = __webpack_public_path__ + "img/pin-neural-core.b7b18f41.png";